import { createFileRoute } from '@tanstack/react-router'
import CreateFolderModalWrapper from '../../../../../containers/project-menu/components/create-folder-modal'
import { createFolderSearchSchema } from '../search-schemas'

export const Route = createFileRoute(
  '/_authenticated/project/_projects/newfolder/'
)({
  validateSearch: createFolderSearchSchema,
  component: CreateFolderModalWrapper
})
